import { AxiosResponse } from 'axios';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { Configuration, LegalApi, AcknowledgementV2Dto } from '@inosio/payments-sdk';
import { selectCurrentUser } from '../../../shared/sagas/auth/authSlice';
import {
  getAcknowledgements,
  setAcknowledgements,
  setAcknowledgementsError,
  getExportAckForm,
  setExportAckForm,
  setExportAckFormError,
  markAcknowledgementAsResolved,
  setMarkAcknowledgementError,
  setMarkAcknowledgementResolved,
} from './acknowledgementsSlice';
import { IpaUserExtended } from '../../../shared/sagas/auth/authSlice';
import { Stream } from 'stream';


const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

export function requestGetAcknowledgements(access_token: string) {
  apiConfig.accessToken = access_token;
  const legalApi = new LegalApi(apiConfig);

  return legalApi.getOutstandingAcknowledgmentsV2();
}

export function requestExportAckForm(access_token: string, acknowledgementUuid: string) {
  apiConfig.accessToken = access_token;

  const responseType = "arraybuffer";
  const contentDisposition = "application/pdf";
  const headerParams = {
    "Content-Disposition": contentDisposition,
  };

  const legalApi = new LegalApi(apiConfig);
  return legalApi.checkOustandingAcknowledgementsDocs(acknowledgementUuid, { responseType, headers: headerParams });
}

export function requestMarkAcknowledgementAsViewed(access_token: string, acknowledgementUuid: string) {
  apiConfig.accessToken = access_token;
  const legalApi = new LegalApi(apiConfig);
  return legalApi.markAcknowledgementViewed(acknowledgementUuid);
}

export function* handleMarkAcknowledgementsAsViewed(action: { type: typeof requestMarkAcknowledgementAsViewed; payload: any }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    yield call(requestMarkAcknowledgementAsViewed, currentUser.accessToken, action.payload.uuid);
    yield put(setMarkAcknowledgementResolved({ uuid: action.payload.uuid }));
  } catch (error: any) {
    yield put(setMarkAcknowledgementError({ message: error?.response?.data?.message }));
  }
}

export function* handleGetAcknowledgements(action: { type: typeof getAcknowledgements; payload: any }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<AcknowledgementV2Dto> = yield call(requestGetAcknowledgements, currentUser.accessToken);

    const { data } = response;
    yield put(setAcknowledgements(data));
  } catch (error: any) {
    yield put(setAcknowledgementsError({ message: error?.response?.data?.message }));
  }
}

export function* handleExportAckForm(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<Stream> = yield call(requestExportAckForm, currentUser.accessToken, action.payload.uuid);

    // download stream
    let fileName = "transaction_details.pdf"; // fallback
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(response.headers["content-disposition"]);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, "");
    }

    const url = window.URL.createObjectURL(new Blob([response.data as unknown as BlobPart], { type: "application/pdf" }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}`);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);

    yield put(setExportAckForm());
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setExportAckFormError({ ...error?.response?.data }));
    } else {
      yield put(setExportAckFormError({ ...error }));
    }
  }
}

export function* acknowledgementsSaga() {
  yield takeLatest(getAcknowledgements.type, handleGetAcknowledgements);
  yield takeLatest(getExportAckForm.type, handleExportAckForm);
  yield takeLatest(markAcknowledgementAsResolved.type, handleMarkAcknowledgementsAsViewed);
}
